// bulkUploadThunks.js
import { serverCall } from "utils/serverCall";
import {
  initBulkUploadRequest,
  setBulkUpload,
  errorBulkUpload,
  bulkUploadProgress,
} from "./action";
import apiEndpoints from "utils/apiList";
import { getToken } from "utils/auth";
import toast from "react-hot-toast";
import { fetchMachineList } from "../redux/dispatcher";

export const bulkUploadMachines = (machineData, toggle,) => {
  return async (dispatch) => {
    dispatch(initBulkUploadRequest());
    try {
      const result = await serverCall(
        apiEndpoints.MACHINE_BULK_UPLOAD,
        "POST",
        dispatch,
        machineData
      );
      console.log(`result:${JSON.stringify(result, null, 2)}`);

      if (result.success) {
        dispatch(fetchMachineList());
        console.log(result?.message);
        // dispatch(setBulkUpload(result?.data?.payload));
        toast.success("Machines uploaded successfully");
        toggle();
      } else {
        console.log(result?.message);
        toast.error(result?.message);
        dispatch(errorBulkUpload(result?.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorBulkUpload(error.message));
    }
  };
};

export const trackBulkUploadProgress = (progress) => {
  return (dispatch) => {
    dispatch(bulkUploadProgress(progress));
  };
};
